module.exports = __webpack_public_path__ + "static/media/orphanleft.d65cf139.png";